<template>
  <div>
    <div v-if="!fileReady" class="text-center pd-20">
      <i class="icon ion-md-refresh tx-30"></i>
      <p>Файл ачааллаж байна...</p>
    </div>
    <div v-else>
      <!-- Office Online Viewer -->
      <iframe
        v-if="viewerType === 'office'"
        :src="officeViewerUrl"
        :style="
          `width:100%; height:calc(100vh - ${minusHeight}px); border: none;`
        "
        ref="officeIframe"
      ></iframe>
      <!-- Google Docs Viewer -->
      <iframe
        v-else-if="viewerType === 'google'"
        :src="googleViewerUrl"
        :style="
          `width:100%; height:calc(100vh - ${minusHeight}px); border: none;`
        "
        ref="googleIframe"
      ></iframe>
      <!-- Fallback: Download link -->
      <div v-else class="text-center pd-20">
        <i class="icon ion-md-document tx-50 tx-gray-500"></i>
        <p class="tx-16 mg-t-10">Файлыг онлайн харах боломжгүй байна</p>
        <a
          :href="file.link"
          target="_blank"
          class="btn btn-primary mg-t-20"
          download
        >
          <i class="icon ion-md-download mg-r-5"></i>
          Файл татах
        </a>
      </div>
    </div>
  </div>
</template>
<script>
import { fileInheritedDetail } from "@/api/media";

export default {
  name: "detail",
  props: {
    propFileId: {
      type: Number,
      default: () => null
    },
    minusHeight: {
      type: Number,
      default: () => 115
    }
  },
  data() {
    return {
      fileReady: false,
      file: {},
      deletingFileId: 0,
      viewerType: "office" // 'office', 'google', 'download'
    };
  },

  computed: {
    encodedFileLink() {
      if (!this.file.link) return "";
      // Хэрэв URL аль хэдийн encode хийгдсэн бол decode хийж, дараа нь дахин encode хийх
      try {
        // URL аль хэдийн encode хийгдсэн эсэхийг шалгах
        const decoded = decodeURIComponent(this.file.link);
        // Хэрэв decode хийх боломжтой бол (аль хэдийн encode хийгдсэн), дараа нь дахин encode хийх
        return encodeURIComponent(decoded);
      } catch (e) {
        // Хэрэв decode хийх боломжгүй бол (encode хийгдээгүй), зүгээр л encode хийх
        return encodeURIComponent(this.file.link);
      }
    },
    officeViewerUrl() {
      if (!this.file.link) return "";
      return `https://view.officeapps.live.com/op/embed.aspx?src=${this.encodedFileLink}`;
    },
    googleViewerUrl() {
      if (!this.file.link) return "";
      return `https://docs.google.com/viewer?url=${this.encodedFileLink}&embedded=true`;
    }
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      let _id = this.propFileId;
      if (_id == undefined) {
        _id = this.$route.params.id;
      }

      fileInheritedDetail({ params: { id: _id }, store: this.$store }).then(
        res => {
          if (res != false) {
            this.file = res.data.file;
            this.fileReady = true;
            // Office viewer-ийг эхлээд оролдох
            this.viewerType = "office";
            // Хэрэв Office viewer ажиллахгүй бол Google viewer руу шилжих
            this.$nextTick(() => {
              this.checkViewerAvailability();
            });
          }
        }
      );
    },
    onViewerError() {
      // Office viewer ажиллахгүй бол Google viewer руу шилжих
      if (this.viewerType === "office") {
        this.viewerType = "google";
        this.$nextTick(() => {
          this.checkViewerAvailability();
        });
      } else if (this.viewerType === "google") {
        // Google viewer бас ажиллахгүй бол download link харуулах
        this.viewerType = "download";
      }
    },
    checkViewerAvailability() {
      // iframe load хийгдсэн эсэхийг шалгах
      const iframe =
        this.viewerType === "office"
          ? this.$refs.officeIframe
          : this.$refs.googleIframe;

      if (iframe) {
        let loadTimeout;
        let checkInterval;

        // Timeout тохируулах - хэрэв 8 секундын дотор load хийгдэхгүй бол дараагийн viewer руу шилжих
        loadTimeout = setTimeout(() => {
          if (this.viewerType === "office") {
            this.viewerType = "google";
            this.$nextTick(() => {
              this.checkViewerAvailability();
            });
          } else if (this.viewerType === "google") {
            this.viewerType = "download";
          }
        }, 8000);

        // Iframe load хийгдсэн эсэхийг шалгах
        iframe.onload = () => {
          clearTimeout(loadTimeout);
          if (checkInterval) clearInterval(checkInterval);

          // Load хийгдсэн ч ажиллахгүй байж болно, тэгэхээр content-ийг шалгах
          setTimeout(() => {
            try {
              // CORS-ийн улмаас content-д хандах боломжгүй байж болно
              // Гэхдээ хэрэв iframe load хийгдсэн бол амжилттай гэж үзэж болно
            } catch (e) {
              // Error гарвал дараагийн viewer руу шилжих
              if (this.viewerType === "office") {
                this.viewerType = "google";
                this.$nextTick(() => {
                  this.checkViewerAvailability();
                });
              }
            }
          }, 2000);
        };

        // Error event (хэрэв боломжтой бол)
        iframe.onerror = () => {
          clearTimeout(loadTimeout);
          if (checkInterval) clearInterval(checkInterval);
          this.onViewerError();
        };
      }
    }
  }
};
</script>
